import { Injectable } from '@angular/core';
import { TradeStoreService } from '../../multisite/trade/trade-store.service';
import { NgInject } from '@df/ng/ng-inject';
import { RespectMustLoginService } from '@df/session/customer/respect-must-login.service';
@Injectable({ providedIn: 'root' })
export class LocalRespectMustLoginService extends RespectMustLoginService {
    @NgInject(TradeStoreService)
    private tradeStoreService!: TradeStoreService;
    protected override mustLogin(): boolean {
        return this.tradeStoreService.isTradeStore();
    }
    protected override isCustomerAllowed(): boolean {
        return this.tradeStoreService.isCommerceAllowed();
    }
}
